import React from 'react';
import { useNavigate } from 'react-router-dom';

const SeeMoreButton = ({ tab, path, label, className = '' }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    localStorage.setItem('activeTab', tab);
    navigate(path);
  };

  return (
    <button
      type="button"
      className={`px-2 sm:px-3 py-1 sm:py-[5px] bg-white rounded-md text-[10px] sm:text-xs font-semibold text-gray-800 transition-colors border border-[#ccd5df] w-fit self-end hover:bg-gray-200 whitespace-nowrap ${className}`}
      onClick={handleClick}
    >
      {label}
    </button>
  );
};

export default SeeMoreButton;
